import React, { Component, Fragment } from 'react'
import { Button, Form, message, Popconfirm, Table } from 'antd'
import moment from 'moment/moment'
import Templates from '../../../../../api/Templates'
import Dropdowns from '../../../../../api/Dropdowns'
import Employees from '../../../../../api/Employees'
import withLoadingSection from '../../../../../elements/HOC/withLoadingSection'
import { compose } from 'recompose'
import StatutoryTypeSelect from '../../../../../elements/Select/Employee/StatutoryType'
import Rates from '../../Contract/Form/Rates'
import InfoText from '../../../../../elements/InfoText'
import TextColumn from '../../../../../elements/Table/Columns/Text'
import NumberColumn from '../../../../../elements/Table/Columns/Number'
import DropdownColumn from '../../../../../elements/Table/Columns/Dropdown'
import { sessionItemVal } from '../../../../../modules/Utils'
import ValueType from '../../../../../elements/Select/Employee/ValueType'
import PayPeriod from '../../../../../elements/Select/Employee/PayPeriod'
import { get, isEmpty, set } from 'lodash'

class Statutory extends Component {
  uuid = moment().unix()

  constructor(props) {
    super(props)
    let data = []
    if (!isEmpty(get(props, 'payQuery.statutory'))) data = props.payQuery.statutory.map((item) => ({ ...item }))
    data.forEach((i) => {
      if (!i.key) i.key = (this.uuid++).toString()
    })
    this.cacheData = data.map((item) => ({ ...item }))
    this.companyKey = (get(props, 'payQuery.contract.company._id') || '').replace('members/', '')
    this.state = {
      data,
      bankList: [],
      payPeriod: [],
      fetchingBank: false,
      statutoryType: [],
    }
    this.api = new Employees()
    this.key = props.employee._key
    this.dropdownApi = new Dropdowns()
    this.templateApi = new Templates()
  }

  fetchStatutoryTemplate = async () => {
    if (isEmpty(this.state.data) && this.props.type !== 'view') {
      try {
        this.setState({ fetchingStatutory: true })
        let employeeTemplate = await this.templateApi.read(this.companyKey, 'employee')
        let data = employeeTemplate['statutory'] || []
        data.forEach((i) => {
          if (!i.key) i.key = (this.uuid++).toString()
        })
        this.setState({ data, fetchingStatutory: false })
        this.props.updatePayQuery('statutory', data)
      } catch (error) {
        console.error(error)
        message.error(error.errorMessage)
        this.setState({
          fetchingStatutory: false,
        })
      }
    }
  }

  columns = [
    {
      title: 'Authority',
      dataIndex: 'authority.name',
      render: (text, record) => this.renderColumnsType(text, record, 'authority.name'),
    },
    {
      title: 'Type',
      dataIndex: 'authority.type',
    },
    {
      title: 'Account Number',
      dataIndex: 'accountNumber',
      render: (text, record) => (
        <TextColumn onChange={this.handleChange} value={text} record={record} column={'accountNumber'} />
      ),
    },
    {
      title: 'Value Type',
      dataIndex: 'value.type',
      render: (text, record) => (
        <DropdownColumn
          onChange={this.handleChange}
          SelectCmp={ValueType}
          display={sessionItemVal('employee_valueType_dropdown', text)}
          value={text}
          record={record}
          column={'value.type'}
        />
      ),
    },
    {
      title: 'Employer Value',
      dataIndex: 'value.employer',
      render: (text, record) => (
        <NumberColumn onChange={this.handleChange} value={text} record={record} column={'value.employer'} />
      ),
    },
    {
      title: 'Employee Value',
      dataIndex: 'value.employee',
      render: (text, record) => (
        <NumberColumn onChange={this.handleChange} value={text} record={record} column={'value.employee'} />
      ),
    },
    {
      title: 'Period',
      dataIndex: 'period',
      render: (text, record) => (
        <DropdownColumn
          onChange={this.handleChange}
          SelectCmp={PayPeriod}
          display={text}
          value={text}
          record={record}
          column={'period'}
        />
      ),
    },
    {
      title: 'Operation',
      dataIndex: 'operation',
      render: (text, record) => {
        const { editable } = record
        return (
          <div className="editable-row-operations">
            {editable ? (
              <span>
                <a onClick={() => this.save(record.key)}>Save</a>
                <span className="ant-divider" />
                <Popconfirm title="Sure to cancel?" onConfirm={() => this.cancel(record.key)}>
                  <a>Cancel</a>
                </Popconfirm>
              </span>
            ) : (
              [
                <a onClick={() => this.edit(record.key)}>Edit</a>,
                <span className="ant-divider" />,
                <Popconfirm title="Sure to remove?" onConfirm={() => this.remove(record.key)}>
                  <a>Remove</a>
                </Popconfirm>,
              ]
            )}
          </div>
        )
      },
    },
  ]
  add = () => {
    const newData = [...this.state.data]
    newData.push({ key: (this.uuid++).toString(), editable: true })
    this.setState({ data: newData })
  }

  cancel(key) {
    const newData = [...this.state.data]
    const target = newData.filter((item) => key === item.key)[0]
    if (target) {
      Object.assign(target, this.cacheData.filter((item) => key === item.key)[0])
      delete target.editable
      if (Object.keys(target).length === 1 && Object.keys(target)[0] === 'key') this.remove(target.key)
      else this.setState({ data: newData })
      this.props.updatePayQuery('statutory', newData)
    }
  }

  remove(key) {
    let newData = [...this.state.data]
    newData = newData.filter((item) => key !== item.key)
    this.setState({ data: newData })
    this.props.updatePayQuery('statutory', newData)
  }

  edit(key) {
    const newData = [...this.state.data]
    const target = newData.filter((item) => key === item.key)[0]
    if (target) {
      target.editable = true
      this.setState({ data: newData })
      this.props.updatePayQuery('statutory', newData)
    }
  }

  save(key) {
    const newData = [...this.state.data]
    const target = newData.filter((item) => key === item.key)[0]
    if (target) {
      delete target.editable
      this.setState({ data: newData })
      this.cacheData = newData.map((item) => ({ ...item }))
      this.props.updatePayQuery('statutory', newData)
    }
  }

  handleChange = (value, key, column) => {
    const newData = [...this.state.data]
    const target = newData.filter((item) => key === item.key)[0]
    if (target) {
      set(target, column, value)
      if (column === 'authority.name') set(target, 'authority.type', this.getStatutoryType(this.companyKey, value))
      this.setState({ data: newData })
    }
  }
  getStatutoryObject = (companyKey) => {
    const data = JSON.parse(sessionStorage.getItem('employee_statutory_dropdown')) || []
    return get(data.find((d) => d._id === `members/${companyKey}`) || {}, 'list') || []
  }
  getStatutoryType = (companyKey, key) => {
    const list = this.getStatutoryObject(companyKey)
    return get(list.find((s) => s.key === key) || {}, 'type')
  }
  getStatutoryName = (companyKey, key) => {
    const list = this.getStatutoryObject(companyKey, key)
    return get(list.find((s) => s.key === key) || {}, 'value')
  }

  renderColumnsType(text, record, column) {
    return record.editable ? (
      <StatutoryTypeSelect
        companyKey={this.companyKey}
        value={text}
        onChange={(value) => this.handleChange(value, record.key, column)}
      />
    ) : (
      this.getStatutoryName(this.companyKey, text)
    )
  }

  clear = () => {
    this.setState({
      data: [],
    })
    this.props.updatePayQuery('statutory', [])
  }

  render() {
    const { type, employee, payQuery } = this.props
    if (type === 'view') this.columns = this.columns.filter((c) => c.dataIndex !== 'operation')
    return (
      <Fragment>
        <Table
          title={() => (
            <div style={{ textAlign: 'right' }}>
              {type !== 'view' && (
                <Fragment>
                  <Button onClick={this.add}>Add Statutory</Button>
                  <Button onClick={this.fetchStatutoryTemplate}>Fetch Template</Button>
                  <Popconfirm title="Sure to clear?" onConfirm={this.clear}>
                    <Button>Clear</Button>
                  </Popconfirm>
                  ,
                </Fragment>
              )}
            </div>
          )}
          loading={this.state.fetchingStatutory}
          pagination={false}
          columns={this.columns}
          dataSource={this.state.data.filter((i) => i.removed !== true)}
          size="small"
          style={{ marginTop: 10 }}
        />
        <InfoText text={'This Rates details are based on selected contract'} />
        <Rates employee={employee} type={'view'} contract={payQuery.contract} />
      </Fragment>
    )
  }
}

Statutory.propTypes = {}
Statutory.defaultProps = {}

export default compose(Form.create(), withLoadingSection)(Statutory)
